import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'reactstrap';
import ClipLoader from 'react-spinners/ClipLoader';
import api from '../../../../Api';
import { connect } from 'react-redux';
import './UserDetailModal.css';

const BRAND_COLORS = {
  primary: '#0e1d3f'
};

export function UserDetailModal(props) {
  const { isOpen, openModal, toggle, data, userId, onBack, translate = {} } = props;

  const [localData, setLocalData] = useState(data || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (data) {
      setLocalData(data);
      setLoading(false);
      return () => { mounted = false; };
    }
    if ((openModal || isOpen) && userId) {
      setLoading(true);
      api.getUser(userId).then(resp => {
        if (!mounted) return;
        const payload = resp && resp.data ? resp.data : null;
        setLocalData(payload);
      }).catch(() => {
        if (!mounted) return;
        setLocalData(null);
      }).finally(() => { if (mounted) setLoading(false); });
    } else if (!isOpen) {
      setLocalData(null);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [userId, isOpen, data]);

  const renderRole = (level) => {
    const map = {
      '4': translate['aluno'] || 'Aluno',
      '3': translate['instrutor'] || 'Instrutor',
      '5': translate['diretor'] || 'Diretor',
      '6': translate['administrador'] || 'Administrador'
    };
    return map[String(level)] || (translate['usuario'] || 'Usuário');
  };

  const avatarSrc = (u) => {
    if (!u) return '/images/defaultAvatar.png';
    const p = u.photo ? String(u.photo).trim() : '';
    if (!p) return '/images/defaultAvatar.png';
    return p;
  };

  const statusInfo = () => {
    const ref = localData;
    if (loading || !ref) return { label: translate['carregando'] || 'Carregando...', className: 'badge-outline-primary' };
    const isBlocked = ref.blocked === true || Number(ref.blocked) === 1 || Number(ref.blocked) === -1;
    return {
      label: isBlocked ? (translate['bloqueado'] || 'Bloqueado') : (translate['nao_bloqueado'] || 'Não bloqueado'),
      className: isBlocked ? 'badge-outline-primary' : 'badge-primary'
    };
  };

  const status = statusInfo();

  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={toggle}
      contentClassName="user-detail-modal"
      style={{ maxWidth: '520px' }}
    >
      <div className="modal-header d-flex align-items-center">
        <h5 className="modal-title mb-0 text-white">{translate['detalhes_do_usuario'] || 'Detalhes do Usuário'}</h5>
        <button aria-label="Close" className="close text-white" data-dismiss="modal" type="button" onClick={toggle}><span aria-hidden={true}>×</span></button>
      </div>
      <div className="modal-body">
        {(loading || localData) ? (
          <div className="user-card text-center">
            <div className="user-avatar shadow-sm">
              <img src={avatarSrc(localData)} alt={localData ? (localData.name || 'avatar') : 'avatar'} />
            </div>
            <h4 className="user-name mb-1">{localData ? `${localData.name || ''} ${localData.lastName || ''}` : ''}</h4>
            <div className="user-role text-uppercase mb-3">{renderRole(localData && localData.accessLevel)}</div>
            <div className={`badge badge-pill user-status ${status.className}`}>{status.label}</div>
            <div className="user-info mt-4 text-left">
              <div className="info-row">
                <span className="info-label"><i className="fas fa-user mr-2"></i>{translate['nome'] || 'Nome'}:</span>
                <span className="info-value">{localData ? `${localData.name || ''} ${localData.lastName || ''}`.trim() : '-'}</span>
              </div>
              <div className="info-row">
                <span className="info-label"><i className="fas fa-envelope mr-2"></i>{translate['email'] || 'E-mail'}:</span>
                <span className="info-value">{localData ? (localData.email || '-') : '-'}</span>
              </div>
              <div className="info-row">
                <span className="info-label"><i className="fas fa-layer-group mr-2"></i>{translate['nivel_acesso'] || 'Nível de acesso'}:</span>
                <span className="info-value">{renderRole(localData && localData.accessLevel)}</span>
              </div>
              <div className="info-row">
                <span className="info-label"><i className="fas fa-shield-alt mr-2"></i>{translate['status'] || 'Status'}:</span>
                <span className="info-value">{status.label}</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-4">
            <ClipLoader size={28} color={BRAND_COLORS.primary} loading={true} />
            <p className="mt-3 mb-0 text-muted">{translate['carregando'] || 'Carregando...'}</p>
          </div>
        )}
      </div>
      <div className="modal-footer d-flex justify-content-between align-items-center w-100">
        <div>
          {onBack && (
            <Button
              color="primary"
              outline
              size="sm"
              className="d-inline-flex align-items-center footer-btn"
              onClick={onBack}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              {translate['voltar'] || 'Voltar'}
            </Button>
          )}
        </div>
        <div>
          <Button
            color="primary"
            size="sm"
            className="d-inline-flex align-items-center footer-btn"
            onClick={toggle}
          >
            <i className="fas fa-times mr-1"></i>
            {translate['fechar'] || 'Fechar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => ({ translate: state.translate }))(UserDetailModal);
